import capitalize from '@mui/utils/capitalize';
export default capitalize;
